/**
 * Metadata and timing debug field definitions
 */

import type { DebugFieldDefinition } from '../types';
import { formatBoolean, formatDate, formatNumber } from './formatters';

export const metadataFields: DebugFieldDefinition[] = [
  {
    id: 'metadata.paymentDate',
    name: 'Payment Date',
    category: 'timing',
    description: 'Date of this payment',
    extractor: (ctx) => ctx.cashFlow?.paymentDate,
    formatter: formatDate,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'metadata.taxYear',
    name: 'Tax Year',
    category: 'timing',
    description: 'Related tax bill year',
    extractor: (ctx) => ctx.cashFlow?.relatedTaxBillYear,
    formatter: (v) => (v !== undefined ? String(v) : 'N/A'),
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'metadata.paymentIndex',
    name: 'Payment Index',
    category: 'metadata',
    description: 'Index in the cash flows array',
    extractor: (ctx) => ctx.paymentIndex,
    formatter: formatNumber,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'metadata.isInterestOnly',
    name: 'Interest Only',
    category: 'timing',
    description: 'Whether this is an interest-only payment period',
    extractor: (ctx) => ctx.cashFlow?.isInterestOnly,
    formatter: formatBoolean,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'metadata.isActive',
    name: 'Is Active',
    category: 'timing',
    description: 'Whether this payment date is active',
    extractor: (ctx) => ctx.cashFlow?.isActive,
    formatter: formatBoolean,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'metadata.isFinalFiscalYear',
    name: 'Final Fiscal Year Payment',
    category: 'timing',
    description: 'Is this the last payment in the fiscal year',
    extractor: (ctx) => ctx.cashFlow?.isFinalFiscalYearPayment,
    formatter: formatBoolean,
    performanceCost: 'low',
    enabledByDefault: false,
  },
  {
    id: 'metadata.fiscalYearEnding',
    name: 'Fiscal Year Ending',
    category: 'timing',
    description: 'Related fiscal year ending date',
    extractor: (ctx) => ctx.cashFlow?.relatedFiscalYearEndingDate,
    formatter: formatDate,
    performanceCost: 'low',
    enabledByDefault: false,
  },
  {
    id: 'metadata.candidateName',
    name: 'Candidate Name',
    category: 'metadata',
    description: 'Name of the candidate being processed',
    extractor: (ctx) => ctx.candidate?.name,
    formatter: (v) => (v !== undefined ? String(v) : 'N/A'),
    performanceCost: 'low',
    enabledByDefault: false,
  },
  {
    id: 'metadata.candidatePhase',
    name: 'Created In Phase',
    category: 'metadata',
    description: 'Processing phase where candidate was created',
    extractor: (ctx) => ctx.candidate?.createdInPhase,
    formatter: (v) => (v !== undefined ? String(v) : 'N/A'),
    performanceCost: 'low',
    enabledByDefault: false,
  },
];
